import { render } from "./OrgSettingsTableActions.vue?vue&type=template&id=0a672521"
import script from "./OrgSettingsTableActions.vue?vue&type=script&lang=js"
export * from "./OrgSettingsTableActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__